export default () => ({
  root: {
    width: '100%'
  }
})



// WEBPACK FOOTER //
// ./components/slices/StaticBanner/styles.js